// *******************************************************************************
// Tabs Module
// *******************************************************************************

// Close all tabs
const closeTabContents = (tabLinks, tabContent) => {
  tabLinks.forEach((elem) => {
    elem.classList.remove('is-active');
  });
  tabContent.forEach((contentElem) => {
    contentElem.classList.remove('is-active');
  });
};

attachEvent('[data-tab-link]', 'click', (ev) => {
  const parentElem = ev.target.closest('.tabs-module');
  const tabLinks = parentElem.querySelectorAll('[data-tab-link]');
  const tabContent = parentElem.querySelectorAll('.tabs-module__tab-content');

  const targetValue = ev.target.getAttribute('href');
  closeTabContents(tabLinks, tabContent);
  ev.target.classList.add('is-active');
  document.querySelector(targetValue).classList.add('is-active');

  ev.preventDefault();
});
